import {
  META_CONSENT_STORAGE_PREFIX,
  META_POLICY_VERSION,
  type MetaConsentDecision,
  type MetaConsentState,
} from './metaPixelTypes';

function storageKey(eventSlug: string): string {
  return `${META_CONSENT_STORAGE_PREFIX}${eventSlug}`;
}

export function getConsent(eventSlug: string): MetaConsentState | null {
  if (!eventSlug || typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(storageKey(eventSlug));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as MetaConsentState;
    if (parsed?.decision !== 'accepted' && parsed?.decision !== 'rejected') return null;
    return parsed;
  } catch {
    return null;
  }
}

export function setConsent(eventSlug: string, decision: MetaConsentDecision): MetaConsentState {
  const state: MetaConsentState = {
    decision,
    timestamp: new Date().toISOString(),
    policyVersion: META_POLICY_VERSION,
  };
  if (typeof window !== 'undefined' && eventSlug) {
    try {
      window.localStorage.setItem(storageKey(eventSlug), JSON.stringify(state));
    } catch {
      /* quota / private mode */
    }
  }
  return state;
}

export function clearConsent(eventSlug: string): void {
  if (!eventSlug || typeof window === 'undefined') return;
  try {
    window.localStorage.removeItem(storageKey(eventSlug));
  } catch {
    /* ignore */
  }
}
